import { API } from "./api";
import { ACCESS_TOKEN, TOKEN_CSRF } from "./authTokens";
import { OkResponse } from "./dashboard";

export const logoutCliente = async () => {
  const res = await API.post<OkResponse>("/auth/logout");
  if (res.data.ok) {
    localStorage.setItem(TOKEN_CSRF, "");
    API.defaults.headers.common["Authorization"] = `Bearer `;
    localStorage.setItem(ACCESS_TOKEN, "");
  }
};
